import React from 'react';
import { Box, Chip } from '@material-ui/core';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { useObjectivesList } from '../../../hooks/useObjectivesList';
import { ObjectiveSelect } from '../../../components/ObjectiveSelect';
import { useTranslation } from 'react-i18next';

export function HomeFilters({ selectedObjectiveId, setSelectedObjectiveId }) {
  const { data: allMonitors, isLoading } = useObjectivesList({ fromStorage: true });
  const { t } = useTranslation();

  const handleObjectiveChange = (objetivoId) => {
    setSelectedObjectiveId(objetivoId);
  };

  return (
    <Box style={{ display: 'flex', alignItems: 'center', gap: '16px', marginRight:'8px' }}>
      <Chip
        icon={<AccessTimeIcon fontSize="small" />}
        label={t('periods.text.24h')}
        size="small"
        style={{
          fontWeight: 600,
          border: '1px solid gray',
          borderRadius: '8px',
          padding: '16px 4px'
        }}
      />
      <Box style={{ width: '300px' }}>
        <ObjectiveSelect 
          objetivos={allMonitors || []}
          objetivoId={selectedObjectiveId || ''}
          setObjetivoId={handleObjectiveChange}
          isLoading={isLoading}
        />
      </Box>
    </Box>
  );
}
